import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  Box,
  CircularProgress
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!username.trim() || !password.trim()) {
      setError('Inserisci username e password');
      setLoading(false);
      return;
    }

    try {
      const result = await login(username, password);
      
      if (!result.success) {
        setError(result.message || 'Credenziali non valide');
      }
    } catch (error) {
      console.error('Errore durante il login:', error);
      setError('Errore di connessione al server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        backgroundColor: '#32373c',
      }}
    >
      {/* Left brand panel */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          px: 6,
          background: 'linear-gradient(135deg, #32373c 0%, #1e2226 100%)',
        }}
      >
        <img
          src="/logo-bionen-white.png"
          alt="Bionen"
          style={{ maxWidth: 280, width: '80%', objectFit: 'contain', marginBottom: 32 }}
        />
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.35)', mt: 2, maxWidth: 320, textAlign: 'center' }}>
          Sistema di gestione ordini e monitoraggio produzione
        </Typography>
      </Box>

      {/* Right login panel */}
      <Box
        sx={{
          flex: { xs: 1, md: '0 0 480px' },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#ffffff',
          px: 4,
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 360 }}>
          {/* Mobile logo */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mb: 4 }}>
            <img
              src="/logo-bionen-white.png"
              alt="Bionen"
              style={{ height: 40, objectFit: 'contain', filter: 'brightness(0)' }}
            />
          </Box>

          <Typography variant="h5" sx={{ fontWeight: 600, color: '#32373c', mb: 0.5 }}>
            Accedi
          </Typography>
          <Typography variant="body2" sx={{ color: '#6b7280', mb: 3 }}>
            Inserisci le tue credenziali per continuare
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2, borderRadius: '8px' }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
              variant="outlined"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              variant="outlined"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, minHeight: 48 }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Accedi'
              )}
            </Button>
          </Box>

          <Typography variant="caption" sx={{ color: '#9ca3af', display: 'block', textAlign: 'center', mt: 4 }}>
            Bionen S.r.l. &middot; bionen.it
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;